import { useMutation } from "redux-query-react";
import { postMarketsDelete } from "api/admin/src";
export const updateForDelete = (marketIds) => ({
    Market: (prevValue) => {
        const updateValue = { ...prevValue };
        marketIds.forEach((id) => {
            delete updateValue[id];
        });
        return updateValue;
    },
    MarketVersions: (prevValue) => {
        const updateValue = { ...prevValue };
        marketIds.forEach((id) => {
            delete updateValue[id];
        });
        return updateValue;
    },
    Markets: (prevValue) => {
        const updateValue = { ...prevValue };
        marketIds.forEach((id) => {
            delete updateValue[id];
        });
        return updateValue;
    }
});
export const optimisticUpdateForDelete = (marketIds) => ({
    Market: (prevValue) => {
        const optimisticValue = { ...prevValue };
        marketIds.forEach((id) => {
            delete optimisticValue[id];
        });
        return optimisticValue;
    },
    MarketVersions: (prevValue) => {
        const optimisticValue = { ...prevValue };
        marketIds.forEach((id) => {
            delete optimisticValue[id];
        });
        return optimisticValue;
    },
    Markets: (prevValue) => {
        const optimisticValue = { ...prevValue };
        marketIds.forEach((id) => {
            delete optimisticValue[id];
        });
        return optimisticValue;
    }
});
export const rollbackForDelete = (marketIds) => ({
    Market: (initialValue, currentValue) => {
        const rollbackValue = {};
        Object.keys(initialValue).forEach((key) => {
            rollbackValue[key] = marketIds.includes(key) ? initialValue[key] : currentValue[key] || initialValue[key];
        });
        Object.keys(currentValue).forEach((key) => {
            if (!rollbackValue[key]) {
                rollbackValue[key] = currentValue[key];
            }
        });
        return rollbackValue;
    },
    MarketVersions: (initialValue, currentValue) => {
        const rollbackValue = {};
        Object.keys(initialValue).forEach((key) => {
            rollbackValue[key] = marketIds.includes(key) ? initialValue[key] : currentValue[key] || initialValue[key];
        });
        Object.keys(currentValue).forEach((key) => {
            if (!rollbackValue[key]) {
                rollbackValue[key] = currentValue[key];
            }
        });
        return rollbackValue;
    },
    Markets: (initialValue, currentValue) => {
        const rollbackValue = {};
        Object.keys(initialValue).forEach((key) => {
            rollbackValue[key] = marketIds.includes(key) ? initialValue[key] : currentValue[key] || initialValue[key];
        });
        Object.keys(currentValue).forEach((key) => {
            if (!rollbackValue[key]) {
                rollbackValue[key] = currentValue[key];
            }
        });
        return rollbackValue;
    }
});
export const useDeleteMarket = (customQueryConfig) => useMutation((request, customQueryParam) => {
    const customQueryConfig1 = {
        optimisticUpdate: optimisticUpdateForDelete(request?.deleteMultipleMarketsRequest?.marketIds ?? []),
        rollback: rollbackForDelete(request?.deleteMultipleMarketsRequest?.marketIds ?? []),
        update: updateForDelete(request?.deleteMultipleMarketsRequest?.marketIds ?? [])
    };
    return postMarketsDelete(request, { ...customQueryConfig1, meta: { ...customQueryConfig?.meta, ...customQueryParam } });
});
